import React, { useEffect, useState } from 'react';
import { Modal } from './UI';
import { TransactionChange, User } from '../types';
import { api } from '../services/api';

const FIELD_LABELS: Record<string, string> = {
    date: 'Дата', type: 'Тип', counterparty_id: 'Контрагент', amount: 'Сумма', category: 'Категория', description: 'Описание',
    status: 'Статус', has_vat: 'С НДС', vat_rate: 'Ставка НДС', kind: 'Вид', has_document: 'Документ', payment_method: 'Способ оплаты',
    bank_account_id: 'Кошелёк', tax_account: 'Счёт налога', payout_label: 'Пометка', salary_part: 'Часть ЗП',
    salary_period: 'Месяц ЗП', transfer_basis: 'Основание', project_id: 'Объект', review_note: 'Пометка «проверить»',
};
const ACTIONS = { create: 'создал', update: 'изменил', delete: 'удалил' };
const show = (v: unknown) => v === null || v === undefined || v === '' ? '—' : typeof v === 'boolean' ? (v ? 'да' : 'нет') : String(v);

// История операции: кто, когда, какие поля (старое → новое)
export const HistoryModal: React.FC<{ txId: string | null; users: User[]; onClose: () => void }> = ({ txId, users, onClose }) => {
    const [items, setItems] = useState<TransactionChange[]>([]);
    useEffect(() => { if (txId) api.getHistory(txId).then(setItems).catch(() => setItems([])); }, [txId]);
    const who = (id: string | null) => users.find(u => u.id === id)?.name || 'Система';
    return (
        <Modal isOpen={!!txId} onClose={onClose} title="История изменений">
            <div className="space-y-3 text-sm max-h-[60vh] overflow-y-auto">
                {items.length === 0 && <p className="text-slate-400">Изменений не записано</p>}
                {items.map(h => (
                    <div key={h.id} className="border-b border-slate-100 pb-2">
                        <div className="text-xs text-slate-500"><strong className="text-slate-800">{who(h.userId)}</strong> {ACTIONS[h.action]} · {new Date(h.at + 'Z').toLocaleString('ru-RU')}</div>
                        {h.action === 'update' && (
                            <ul className="mt-1 text-xs space-y-0.5">
                                {Object.entries(h.changes).map(([f, [a, b]]) => (
                                    <li key={f}><span className="text-slate-500">{FIELD_LABELS[f] || f}:</span> <span className="line-through text-slate-400">{show(a)}</span> → <strong>{show(b)}</strong></li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </Modal>
    );
};
